import {
    Box,
    Button,
    CloseButton,
    Container,
    createListCollection,
    Dialog,
    Field,
    Flex,
    Grid,
    GridItem,
    Input,
    Portal,
    Select,
    Separator,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import moment from "moment";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { usePostFormMutation } from "@/hooks/microservicesApi";
import { emailRegex } from "@/utilities/text/regex";

const PopupCitaGuiaRent = ({
    isRentOpen,
    onRentClose,
    fecha,
    hora,
    tipo,
    id,
    hubspotForm,
    conCita,
}) => {
    const isLogin = false;
    const isAdmin = false;
    const browserLocation = typeof window === "undefined" ? "" : window.location.href;
    const [nombre, setNombre] = useState(null);
    const [apellidoPaterno, setApellidoPaterno] = useState(null);
    const [telefono, setTelefono] = useState(null);
    const [email, setEmail] = useState(null);
    const [telefonoError, setTelefonoError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [terminos, setTerminos] = useState(false);
    const [fechaM, setFechaM] = useState(null);
    const [horaM, setHoraM] = useState(hora ? hora : "10:00 am");
    const history = useRouter();

    const isBetweenBaseAndMd = useBreakpointValue({ base: true, md: false });

    const nombreError = nombre === "";
    const apellidoError = apellidoPaterno === "";
    const [postForm] = usePostFormMutation();

    useEffect(() => {
        if (!fecha) {
            setFechaM(getTomorrowDate());
        } else {
            setFechaM(fecha);
        }
    }, [fecha]);

    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split("T")[0];
    };

    const handleSubmit = () => {
        let data_send = {
            id: hubspotForm,
            body: {
                fields: [
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: apellidoPaterno,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: telefono,
                    },
                    {
                        name: "wiggot",
                        value: id,
                    },
                    {
                        name: "url_de_propiedad",
                        value: browserLocation,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx",
                    pageName: "Grupo Guia | " + tipo + " " + id,
                },
            },
        };

        // si es con cita, agrego los campos de cita
        if (conCita) {
            data_send.body.fields = [
                ...data_send.body.fields,
                {
                    name: "fecha_de_cita_",
                    value: moment(fechaM).format("DD/MM/YYYY"),
                },
                {
                    name: "hora_de_cita_",
                    value: hora || horaM,
                },
            ];
        }

        postForm(data_send).then((data_w) => {
            //setShowSuccess(true);

            onRentClose();
            history.push("/desarrollos/thankyoupage-agenda-cita");
        });
    };

    const frameworks = createListCollection({
        items: [
            { value: "10:00 am", label: "10:00 am" },
            { value: "11:00 am", label: "11:00 am" },
            { value: "12:00 pm", label: "12:00 pm" },
            { value: "1:00 pm", label: "1:00 pm" },
            { value: "2:00 pm", label: "2:00 pm" },
            { value: "3:00 pm", label: "3:00 pm" },
            { value: "4:00 pm", label: "4:00 pm" },
            { value: "5:00 pm", label: "5:00 pm" },
            { value: "6:00 pm", label: "6:00 pm" },
        ],
    });

    return (
        <>
            <Portal>
                <Dialog.Root
                    open={isRentOpen}
                    onOpenChange={() => onRentClose()}
                    size="sm"
                    preventScroll
                    placement="center"
                >
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Dialog.Content bg="#f8f8f8" p={5}>
                            <Dialog.CloseTrigger asChild zIndex="modal">
                                <CloseButton />
                            </Dialog.CloseTrigger>
                            <Dialog.Body color="black">
                                <Stack direction="column">
                                    <Container alignSelf="center" textAlign="center">
                                        <Text fontWeight="700" fontSize="lg" mb={2}>
                                            {conCita ? "Agendar cita" : "Rentar sin Aval"}
                                        </Text>
                                        {isBetweenBaseAndMd && (
                                            <Text
                                                fontWeight="500"
                                                fontSize="xs"
                                                mb={2}
                                                color="black"
                                                textAlign="left"
                                            ></Text>
                                        )}
                                    </Container>
                                </Stack>
                                <Stack direction="column" mt={6}>
                                    <Container
                                        alignSelf="center"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        {conCita && (
                                            <>
                                                <Grid
                                                    templateColumns="repeat(2, 1fr)"
                                                    gap={0}
                                                    borderRadius="md"
                                                    alignSelf="center"
                                                    bg="#ffffff"
                                                    borderWidth={1}
                                                    borderStyle="solid"
                                                    borderColor="#4F4F4F"
                                                    mb="5"
                                                >
                                                    <GridItem
                                                        colSpan={1}
                                                        borderRightWidth={1}
                                                        borderStyle="solid"
                                                        px={1}
                                                        py={1}
                                                        borderColor="#4F4F4F"
                                                        textAlign="center"
                                                        h="100%"
                                                        color="black"
                                                    >
                                                        <Field.Root
                                                            invalid={!fechaM}
                                                            alignItems="center"
                                                            h="100%"
                                                            required
                                                        >
                                                            <Field.Label
                                                                fontSize="xs"
                                                                fontWeight="bold"
                                                                mb="0"
                                                                display="contents"
                                                            >
                                                                Dia
                                                            </Field.Label>
                                                            <Input
                                                                type="date"
                                                                value={fechaM}
                                                                onChange={(e) =>
                                                                    setFechaM(e.target.value)
                                                                }
                                                                min={getTomorrowDate()}
                                                                size="sm"
                                                                textAlign="center"
                                                                border="none"
                                                                color="gray.600"
                                                                _focus={{
                                                                    outline: "none",
                                                                }}
                                                                mt={1}
                                                                px={2}
                                                            />
                                                        </Field.Root>
                                                    </GridItem>
                                                    <GridItem
                                                        colSpan={1}
                                                        px={1}
                                                        py={1}
                                                        textAlign="center"
                                                        h="100%"
                                                    >
                                                        <Select.Root
                                                            collection={frameworks}
                                                            id="horaCita"
                                                            variant="unstyled"
                                                            //_focus={"0"}
                                                            //w='70%'
                                                            onValueChange={(details) =>
                                                                setHoraM(details.value[0])
                                                            }
                                                            value={[horaM]}
                                                        >
                                                            <Select.HiddenSelect />
                                                            <Select.Label
                                                                fontSize="xs"
                                                                fontWeight="bold"
                                                                mb="0"
                                                                htmlFor="horaCita"
                                                                color="black"
                                                            >
                                                                Hora
                                                            </Select.Label>
                                                            <Select.Control>
                                                                <Select.Trigger
                                                                    pl={4}
                                                                    rounded="full"
                                                                >
                                                                    <Select.ValueText
                                                                        placeholder="Hora"
                                                                        overflowWrap="break-word"
                                                                        whiteSpace="normal"
                                                                        color="gray.600"
                                                                    />
                                                                </Select.Trigger>
                                                                <Select.IndicatorGroup pr={4}>
                                                                    <Select.Indicator />
                                                                </Select.IndicatorGroup>
                                                            </Select.Control>
                                                            <Select.Positioner>
                                                                <Select.Content p={2}>
                                                                    {frameworks?.items?.map(
                                                                        (framework) => (
                                                                            <Select.Item
                                                                                item={framework}
                                                                                key={
                                                                                    framework.value
                                                                                }
                                                                                p={1}
                                                                                color="gray.600"
                                                                            >
                                                                                {framework.label}
                                                                                <Select.ItemIndicator />
                                                                            </Select.Item>
                                                                        )
                                                                    )}
                                                                </Select.Content>
                                                            </Select.Positioner>
                                                        </Select.Root>
                                                    </GridItem>
                                                </Grid>
                                                <Separator
                                                    borderTopWidth={1}
                                                    borderStyle="solid"
                                                    borderColor="gray.200"
                                                    _dark={{ borderColor: "gray.700" }}
                                                />
                                            </>
                                        )}
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSubmit();
                                            }}
                                        >
                                            <Field.Root
                                                invalid={nombreError}
                                                marginTop="8"
                                                gap={0}
                                                required
                                            >
                                                <Input
                                                    rounded="full"
                                                    px="4"
                                                    borderWidth={1}
                                                    borderColor="gray.200"
                                                    focusBorderColor="gray.200"
                                                    errorBorderColor="gray.200"
                                                    id="nombres"
                                                    placeholder="Nombre(s) *"
                                                    type="text"
                                                    defaultValue={
                                                        isLogin && !isAdmin ? user.names : ""
                                                    }
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        setNombre(e.target.value);
                                                    }}
                                                    onBlur={(e) => {
                                                        e.preventDefault();
                                                        setNombre(e.target.value);
                                                    }}
                                                />
                                                {nombreError && (
                                                    <Field.ErrorText ml="4" color="red.500">
                                                        El nombre es necesario
                                                    </Field.ErrorText>
                                                )}
                                            </Field.Root>
                                            <Field.Root
                                                invalid={apellidoError}
                                                mt="5"
                                                required
                                                gap={0}
                                            >
                                                <Input
                                                    rounded="full"
                                                    px="4"
                                                    borderWidth={1}
                                                    borderColor="gray.200"
                                                    focusBorderColor="gray.200"
                                                    errorBorderColor="gray.200"
                                                    id="apellidoPaterno"
                                                    placeholder="Apellido Paterno *"
                                                    type="text"
                                                    defaultValue={
                                                        isLogin && !isAdmin ? user.last_name : ""
                                                    }
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        setApellidoPaterno(e.target.value);
                                                    }}
                                                    onBlur={(e) => {
                                                        e.preventDefault();
                                                        setApellidoPaterno(e.target.value);
                                                    }}
                                                />
                                                {apellidoError && (
                                                    <Field.ErrorText ml="4" color="red.500">
                                                        El apellido es necesario
                                                    </Field.ErrorText>
                                                )}
                                            </Field.Root>
                                            <Field.Root
                                                mt="5"
                                                invalid={telefonoError}
                                                required
                                                gap={0}
                                            >
                                                <Input
                                                    onInvalid={() => setTelefonoError(true)}
                                                    rounded="full"
                                                    px="4"
                                                    borderWidth={1}
                                                    borderColor="gray.200"
                                                    focusBorderColor="gray.200"
                                                    errorBorderColor="gray.200"
                                                    type="tel"
                                                    id="telefono"
                                                    placeholder="Teléfono *"
                                                    required
                                                    defaultValue={
                                                        isLogin && !isAdmin ? user.phone : ""
                                                    }
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        setTelefono(e.target.value);
                                                        if (
                                                            e.target.value.length >= 10 &&
                                                            e.target.value.trim() !== ""
                                                        ) {
                                                            setTelefonoError(false);
                                                        } else {
                                                            setTelefonoError(true);
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        e.preventDefault();
                                                        setTelefono(e.target.value);
                                                        if (
                                                            e.target.value.length >= 10 &&
                                                            e.target.value.trim() !== ""
                                                        ) {
                                                            setTelefonoError(false);
                                                        } else {
                                                            setTelefonoError(true);
                                                        }
                                                    }}
                                                />
                                                {telefonoError && (
                                                    <Field.ErrorText ml="4" color="red.500">
                                                        El teléfono no es válido
                                                    </Field.ErrorText>
                                                )}
                                            </Field.Root>
                                            <Field.Root
                                                mt="5"
                                                invalid={emailError}
                                                gap={0}
                                                required
                                            >
                                                <Input
                                                    onInvalid={() => setEmailError(true)}
                                                    rounded="full"
                                                    px="4"
                                                    borderWidth={1}
                                                    borderColor="gray.200"
                                                    focusBorderColor="gray.200"
                                                    errorBorderColor="gray.200"
                                                    type="email"
                                                    id="email"
                                                    placeholder="Correo electrónico *"
                                                    required
                                                    defaultValue={
                                                        isLogin && !isAdmin ? user.email : ""
                                                    }
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        setEmail(e.target.value);
                                                        setEmailError(
                                                            !emailRegex.test(e.target.value)
                                                        );
                                                    }}
                                                    onBlur={(e) => {
                                                        e.preventDefault();
                                                        setEmail(e.target.value);
                                                        if (!emailRegex.test(e.target.value)) {
                                                            setEmailError(true);
                                                        } else {
                                                            setEmailError(false);
                                                        }
                                                    }}
                                                />
                                                {emailError && (
                                                    <Field.ErrorText ml="4" color="red.500">
                                                        La dirección de correo no es válida
                                                    </Field.ErrorText>
                                                )}
                                            </Field.Root>
                                            <Field.Root mt="5">
                                                <Flex>
                                                    <Checkbox
                                                        px="2"
                                                        id="terminos"
                                                        onChange={(e) => {
                                                            setTerminos(e.target.checked);
                                                        }}
                                                        color="accent.500"
                                                        colorPalette="blue"
                                                    />
                                                    <Text>
                                                        Acepto los{" "}
                                                        <Link
                                                            href="/terminosycondiciones"
                                                            target="_blank"
                                                        >
                                                            Términos y condiciones
                                                        </Link>{" "}
                                                        de Grupo Guía.
                                                    </Text>
                                                </Flex>
                                            </Field.Root>
                                            <Box
                                                w="100%"
                                                justifyContent="center"
                                                display="flex"
                                                mt="5"
                                            >
                                                <Button
                                                    mt="5"
                                                    paddingLeft="10"
                                                    paddingRight="10"
                                                    rounded="full"
                                                    fill="true"
                                                    fontWeight="500"
                                                    color="black"
                                                    _hover={{
                                                        bg: "#EDBE00",
                                                    }}
                                                    type="submit"
                                                    disabled={
                                                        !terminos ||
                                                        nombreError ||
                                                        apellidoError ||
                                                        telefonoError ||
                                                        emailError
                                                    }
                                                    bg="brand.500"
                                                >
                                                    Enviar
                                                </Button>
                                            </Box>
                                        </form>
                                    </Container>
                                </Stack>
                            </Dialog.Body>
                            <Dialog.Footer />
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>
            </Portal>
        </>
    );
};

export default PopupCitaGuiaRent;
